export default __webpack_public_path__ + "static/media/Michael_Mamich_Resume.2aacea39.pdf";